import React from 'react';
import { motion } from 'framer-motion';
import { Palette, Layout, Code, Globe } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <Palette className="w-8 h-8" data-id="element-182" />,
    title: 'UI/UX Design',
    description: 'Creating intuitive and visually appealing user interfaces that enhance user experience and engagement.'
  }, {
    icon: <Layout className="w-8 h-8" data-id="element-183" />,
    title: 'WordPress Dev',
    description: 'Custom WordPress themes and plugins tailored to your specific business needs and requirements.'
  }, {
    icon: <Code className="w-8 h-8" data-id="element-184" />,
    title: 'Web Development',
    description: 'Building responsive, fast, and secure websites using modern technologies and best practices.'
  }, {
    icon: <Globe className="w-8 h-8" data-id="element-185" />,
    title: 'Brand Identity',
    description: 'Crafting unique brand identities including logos, color palettes, and typography that stand out.'
  }];
  return <section id="services" className="py-24 bg-dark relative" data-id="element-186">
      <div className="max-w-[1320px] mx-auto px-4" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-white font-syne mb-4" data-id="element-189">
            My <span className="text-gold" data-id="element-190">Services</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-white/60 font-inter max-w-2xl mx-auto" data-id="element-191">
            I offer a comprehensive range of digital services to help your
            business grow and succeed in the digital age.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-192">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-dark-lighter p-8 rounded-2xl border border-white/5 hover:border-gold/50 transition-all duration-300 hover:-translate-y-2" data-id="element-193">
              <div className="w-16 h-16 bg-dark rounded-full flex items-center justify-center mb-6 text-gold group-hover:scale-110 transition-transform duration-300 border border-white/5 group-hover:border-gold" data-id="element-194">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-white font-syne mb-4 group-hover:text-gold transition-colors" data-id="element-195">
                {service.title}
              </h3>
              <p className="text-white/60 font-inter leading-relaxed text-sm" data-id="element-196">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}